import React from "react";
import "../../Components/Menu/Menu.css";

export default function Questions() {
  return (
    <div>
      <h4 className="sub-title">Har du spørsmål om Bilista?</h4>
      <p className="content">
        Hvis du har spørsmål om Bilista, kan du besøke nettsiden
        <a className="mail-lab" href="https://www.bilista.no">
          www.bilista.no
        </a>
        .Finner du ikke det du leter etter, kan du bruke
        tilbakemeldingsfunksjonen i appen eller kontakte oss på e-postadressen
        <a className="mail-lab" href="mailto:hei@bilista.no">
          hei@bilista.no
        </a>
      </p>
    </div>
  );
}
